import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { GET_CITY, GET_COUNTRY } from 'services/api';
import { rejectValue } from 'redux/helpers';
import { SEARCH, SEARCH_CITY, SEARCH_COUNTRY } from './types';

export const initialState = {
  country: {
    isLoading: null,
    result: [],
  },
  city: {
    isLoading: null,
    result: [],
  },
};

export const searchCity = createAsyncThunk(
  SEARCH_CITY,
  async (payload, { dispatch, rejectWithValue, signal }) => {
    try {
      const source = axios.CancelToken.source();
      signal.addEventListener('abort', () => {
        source.cancel();
      });
      const { data } = await GET_CITY(payload, source.token);
      return data;
    } catch (error) {
      return rejectWithValue(rejectValue(error.response));
    }
  }
);

export const searchCountry = createAsyncThunk(
  SEARCH_COUNTRY,
  async (payload, { dispatch, rejectWithValue, signal }) => {
    try {
      const source = axios.CancelToken.source();
      signal.addEventListener('abort', () => {
        source.cancel();
      });
      const { data } = await GET_COUNTRY(payload, source.token);
      return data;
    } catch (error) {
      return rejectWithValue(rejectValue(error.response));
    }
  }
);

const searchSlice = createSlice({
  name: SEARCH,
  initialState,
  reducers: {
    clearCityResult: (state) => {
      state.city = initialState.city;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchCity.pending, (state) => {
        state.city.isLoading = true;
      })
      .addCase(searchCountry.pending, (state) => {
        state.country.isLoading = true;
      })
      .addCase(searchCity.fulfilled, (state, { payload }) => {
        state.city.isLoading = false;
        state.city.result = payload;
      })
      .addCase(searchCountry.fulfilled, (state, { payload }) => {
        state.country.isLoading = false;
        state.country.result = payload;
      })
      .addCase(searchCity.rejected, (state, { meta }) => {
        if (!meta.aborted) {
          state.city.isLoading = false;
        }
      })
      .addCase(searchCountry.rejected, (state) => {
        state.country.isLoading = false;
      });
  },
});

export const { clearCityResult } = searchSlice.actions;
export default searchSlice.reducer;
